import { Button } from "@/shared";
import { ThreadEmptyIcon } from "../../icons";
import { useFilter } from "../../providers";

export const Empty = () => {
  const { setFilter, filter, setIsForMeFilter } = useFilter();
  return (
    <div className="tw-mt-32 tw-flex tw-flex-col tw-items-center">
      <div className="tw-flex tw-w-[166px] tw-items-center tw-justify-center">
        <ThreadEmptyIcon />
      </div>
      <h2 className="tw-my-4 tw-font-sans tw-text-lg tw-font-bold">
        {filter === "all" && "No comments found"}
        {filter === "resolved" && "No resolved comments found"}
        {filter === "opened" && "No open comments found"}
      </h2>
      {filter === "all" && (
        <p className="tw-text-center tw-font-sans tw-text-[13px]/tight tw-font-normal">
          Click the comment icon on any element <br /> or slide to share your
          thoughts
        </p>
      )}
      {filter !== "all" && (
        <Button
          size="small"
          variant="secondary"
          title="Go back to all comments"
          onClick={() => {
            setIsForMeFilter(false);
            setFilter("all");
          }}
        />
      )}
    </div>
  );
};
